let fallback: () => void = () => {};

export function setFormInvalidFallback(fn: () => void): void {
	fallback = fn;
}

export function getFormInvalidFallback(): () => void {
	return fallback;
}
